import {
	SET_FORM_STATE,
	GET_SOW_LIST,
	GET_SOW_TYPE,
	GET_SOW_TECHS,
	GET_SOW_RMOD,
} from '../actions/ScfActions.js';

const initialState = {
	sowType: [],
	sowTechs: [],
	sowRmod: [],
	formState: {
		isValid: false,
		values: {
			sran: true,
		},
		touched: {},
		errors: {},
	},
};

const scfReducer = (state = initialState, action) => {
	switch (action.type) {
					case SET_FORM_STATE: {
						return {
							...state,
							formState: { ...state.formState, ...action.formState }
						};
					}
					case GET_SOW_TYPE: {
						return {
							...state,
							sowType: action.sowType
						};
					}
					case GET_SOW_TECHS: {
						return {
							...state,
							sowTechs: action.sowTechs
						};
					}
					case GET_SOW_RMOD: {
						return {
							...state,
							sowRmod: action.sowRmod
						};
					}
					default: {
						return state;
					}
	}
};

export default scfReducer;
